import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5534ffc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex overflow-hidden justify-content-between mt-s2" }

import BigNumber from 'bignumber.js';
import { computed, ref, watch } from 'vue';
import { DEFAULT_BRIDGE_DECIMALS } from '@/store/modules/bridge/constants/AMOUNT_LIMITS_FOR_BRIDGE';
import { BalanceError } from '@/sdk/errors';
import { Token } from '@/sdk/entities/token';
import { Direction } from '@/store/modules/bridge/models/direction';
import TokenLabel from '@/components/token/TokenLabel.vue';
import InputBalance from '@/components/form/InputBalance.vue';
import BaseInputNumber from '@/components/form/BaseInputNumber.vue';
import TokenSelect from '@/views/pages/bridge/tokenSelect/TokenSelect.vue';
import { useCardanoBridge } from '@/store/modules/bridge/useCardanoBridge';
import { useEVMWallet } from '@/store/modules/wallet/useEVMWallet';
import { useCardanoWallet } from '@/store/modules/wallet/useCardanoWallet';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputPanel',
  props: {
    modelValue: null,
    loading: { type: Boolean },
    token: null,
    selectedTokenDecimals: null,
    balance: null,
    adaBalance: null,
    notMaxButton: { type: Boolean },
    showBalance: { type: Boolean },
    readonly: { type: Boolean },
    direction: null
  },
  emits: ['update:modelValue', 'tokenSelected'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  modelValue: string;
  loading: boolean;
  token: Token;
  selectedTokenDecimals: number;
  balance: string;
  adaBalance: string;
  notMaxButton: boolean;
  showBalance: boolean;
  readonly: boolean;
  direction: Direction;
}

const PLACEHOLDER_INPUT = '0.0';





const { bridgeForm, calculateMaxAmount } = useCardanoBridge();
const { walletState } = useEVMWallet();
const cardanoWallet = useCardanoWallet();

const isPanelFocus = ref(false);
const setPanelFocus = (value: boolean) => {
  isPanelFocus.value = value;
};

const isCalculatingMax = ref(false);

const inputValue = ref(props.modelValue);

const isWalletsInjected = computed(() => walletState.isInjected && cardanoWallet.isInjected);

const isCryptoOnBalance = computed(() => new BigNumber(props.balance).gt(0));

const balanceStruct = computed(() => ({
  value: props.balance,
  symbol: props.token.unwrapWETH().symbol,
}));

const isBalanceError = computed(() => {
  return bridgeForm.errors?.find(error => error instanceof BalanceError) || false;
});

function onTokenSelected() {
  emits('tokenSelected');
}

function onChangeInput(value) {
  emits('update:modelValue', value);
}

async function onSetMax() {
  console.log('[BRIDGE] balance : ', props.balance);
  isCalculatingMax.value = true;
  const balance = await calculateMaxAmount(new BigNumber(props.balance));
  isCalculatingMax.value = false;

  emits('update:modelValue', balance.toFixed(DEFAULT_BRIDGE_DECIMALS, BigNumber.ROUND_DOWN));
}

watch(
  () => props.modelValue,
  value => {
    inputValue.value = value;
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex-column input-panel mt-s2", {
      'panel-focus': isPanelFocus.value,
      'panel-error': _unref(bridgeForm).errors.length && __props.direction === 'from' && _unref(isWalletsInjected),
      'panel-readonly': __props.readonly,
    }])
  }, [
    _createVNode(InputBalance, {
      class: _normalizeClass({ hidden: !__props.showBalance }),
      "balance-value": _unref(balanceStruct).value,
      "balance-symbol": _unref(balanceStruct).symbol,
      isBalanceError: _unref(isBalanceError) && __props.direction === 'from',
      "not-max-button": __props.notMaxButton,
      isMaxDisabled: !_unref(isCryptoOnBalance),
      onSetMax: onSetMax
    }, null, 8, ["class", "balance-value", "balance-symbol", "isBalanceError", "not-max-button", "isMaxDisabled"]),
    _createElementVNode("div", _hoisted_1, [
      (__props.readonly || isCalculatingMax.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(TokenLabel, { token: __props.token }, null, 8, ["token"]),
            (!__props.loading && !isCalculatingMax.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["text-right flex-grow-1 inputtext-lg ml-s2", { 'text-muted': !__props.modelValue }])
                }, _toDisplayString(__props.modelValue || PLACEHOLDER_INPUT), 3))
              : (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 1,
                  class: "w-9rem h-2rem ml-s2"
                }))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(TokenSelect, {
              direction: __props.direction,
              onTokenSelected: onTokenSelected
            }, null, 8, ["direction"]),
            _createVNode(BaseInputNumber, {
              modelValue: inputValue.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
              placeholder: PLACEHOLDER_INPUT,
              maxFractionDigits: __props.selectedTokenDecimals,
              onInput: _cache[1] || (_cache[1] = ($event: any) => (onChangeInput($event))),
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (setPanelFocus(true))),
              onBlur: _cache[3] || (_cache[3] = ($event: any) => (setPanelFocus(false))),
              "input-class": "inputtext-lg ml-s2",
              min: 0
            }, null, 8, ["modelValue", "maxFractionDigits"])
          ], 64))
    ])
  ], 2))
}
}

})